/*
  FormattedMessages.js - FormattedMessages for editComponent within Single View Customer of topuser reports Component

  Author: Julius Klaebe (2019)
  Company: Virtual Ark
*/

// NPM MODULES
import React from 'react';
import { FormattedMessage } from 'react-intl';

const FormattedMessages = {
  name: (
    <FormattedMessage id="Global.Name" defaultMessage="Name"></FormattedMessage>
  ),
  addNewAdmin: (
    <FormattedMessage
      id="Global.AddNewAdmin"
      defaultMessage="Add New Admin"
    ></FormattedMessage>
  ),
  department: (
    <FormattedMessage
      id="Global.Department"
      defaultMessage="Department"
    ></FormattedMessage>
  ),
  searchButton: (
    <FormattedMessage id="Global.SearchButton" defaultMessage="Search" />
  ),
  loading: <FormattedMessage id="Global.Loading" defaultMessage="Loading..." />,
  email: (
    <FormattedMessage
      id="Global.Email"
      defaultMessage="Email"
    ></FormattedMessage>
  ),
  accessLevel: (
    <FormattedMessage
      id="Global.AccessLevel"
      defaultMessage="Access Level"
    ></FormattedMessage>
  ),
  contactType: (
    <FormattedMessage
      id="Global.ContactType"
      defaultMessage="Contact Type"
    ></FormattedMessage>
  ),
  contactStatus: (
    <FormattedMessage
      id="Global.ContactStatus"
      defaultMessage="Contact Status"
    ></FormattedMessage>
  ),
  addNew: (
    <FormattedMessage
      id="Global.AddNew"
      defaultMessage="Add New"
    ></FormattedMessage>
  ),
  fullAdminAccess: (
    <FormattedMessage
      id="Global.FullAdminAccess"
      defaultMessage="Full Administration Access"
    ></FormattedMessage>
  ),
  accountAndReport: (
    <FormattedMessage
      id="Global.AccountAndReport"
      defaultMessage="Accounts and Reports"
    ></FormattedMessage>
  ),
  helpDesk: (
    <FormattedMessage
      id="Global.HelpDesk"
      defaultMessage="Help desk"
    ></FormattedMessage>
  ),
  noAccessLevel: (
    <FormattedMessage
      id="Global.NoAccessLevel"
      defaultMessage="No access Level"
    ></FormattedMessage>
  ),
  primaryTech: (
    <FormattedMessage
      id="Global.PrimaryTech"
      defaultMessage="Primary Technical"
    ></FormattedMessage>
  ),
  secondTech: (
    <FormattedMessage
      id="Global.SecondTech"
      defaultMessage="Secondary Technical"
    ></FormattedMessage>
  ),
  primaryBill: (
    <FormattedMessage
      id="Global.PrimaryBill"
      defaultMessage="Primary Billing"
    ></FormattedMessage>
  ),
  secondBill: (
    <FormattedMessage
      id="Global.SecondBill"
      defaultMessage="Secondary Billing"
    ></FormattedMessage>
  ),
  primarySales: (
    <FormattedMessage
      id="Global.PrimarySales"
      defaultMessage="Primary Sales"
    ></FormattedMessage>
  ),
  secondSales: (
    <FormattedMessage
      id="Global.SecondSales"
      defaultMessage="Secondary Sales"
    ></FormattedMessage>
  ),
  modalBody: (
    <FormattedMessage
      id="Global.ModalBody"
      defaultMessage="A user already exists with that email address. Do you want to upgrade that user to an Administrator? (Password will remain unchanged, but name and mobile number will be updated)"
    ></FormattedMessage>
  ),
  modalTitle: (
    <FormattedMessage
      id="Global.ModalTitle"
      defaultMessage="User Upgrade Confirmation"
    ></FormattedMessage>
  ),
};

export default FormattedMessages;
